import { soft } from "./softClasses";

function Block({ w, h, round = "rounded-md", className = "" }) {
  return (
    <span
      className={`block animate-pulse bg-terakkiBrandMist dark:bg-white/10 ${round} ${className}`}
      style={{ width: w, height: h }}
    />
  );
}

/**
 * Sekmelerin iskeleti: gerçek yerleşimle aynı ölçüler (özet şeridi + satırlar),
 * veri gelince bir şey kaymasın.
 * layout: "highlights" | "titles" | "ranking" | "rows"
 */
export default function InsightsSkeleton({ layout = "rows", rows = 6 }) {
  const summary =
    layout === "highlights" ? (
      <div className={`${soft.summary} flex flex-col gap-3.5`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <Block w={112} h={36} round="rounded-full" />
            <Block w={90} h={14} />
          </div>
          <Block w={64} h={30} />
        </div>
        <Block w="100%" h={4} round="rounded-full" />
        <div className="flex">
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex-1 flex flex-col items-center gap-1.5">
              <Block w={28} h={17} />
              <Block w={56} h={11} />
            </div>
          ))}
        </div>
      </div>
    ) : layout === "titles" ? (
      <div className={`${soft.summary} flex items-center gap-3`}>
        <Block w={48} h={48} round="rounded-full" />
        <div className="flex-1 flex flex-col gap-1.5">
          <Block w="45%" h={17} />
          <Block w="65%" h={13} />
        </div>
      </div>
    ) : layout === "ranking" ? (
      <div className={`${soft.summary} flex items-center justify-between`}>
        <Block w={112} h={36} round="rounded-full" />
        <div className="flex flex-col items-end gap-1">
          <Block w={82} h={11} />
          <Block w={44} h={22} />
        </div>
      </div>
    ) : null;

  return (
    <div aria-busy="true" className="flex flex-col">
      {summary}
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={soft.row}>
          {layout === "ranking" ? <Block w={22} h={14} /> : <Block w={36} h={36} round="rounded-full" />}
          <div className="flex-1 flex flex-col gap-1.5">
            <Block w="50%" h={15} />
            {layout === "ranking" ? <Block w="100%" h={4} round="rounded-full" /> : <Block w="35%" h={11} />}
          </div>
          <Block w={40} h={15} />
        </div>
      ))}
    </div>
  );
}
